import { useEffect } from 'react'

/**
 * Закрытие по клику вне элемента.
 *
 * Раньше каждый выпадающий список сам вешал слушатель на document.
 * Кроме дублирования это утечка абстракции: в нативной сборке document
 * не существует, а поведение нужно то же.
 */
export function useClickOutside(ref, onOutside, enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onOutside()
    }
    globalThis.document?.addEventListener('mousedown', handler)
    return () => globalThis.document?.removeEventListener('mousedown', handler)
  }, [ref, onOutside, enabled])
}
